import { type CouponContent, type CouponInformationProps } from '../types/coupon-information.types';
import { type SalesRule } from '../../../types/front.graphql';

export const useMapSalesRuleToCouponType = () => {
    const mapSalesRuleToCouponType = (salesRule: SalesRule): CouponInformationProps => {
        return {
            id: salesRule.code ?? '',
            startDate: salesRule.from_date ?? '',
            endDate: salesRule.to_date ?? '',
            devices: 'Tất cả thiết bị', // Assuming default value
            shippingAddress: 'Giao hàng nhanh, Giao hàng tiết kiệm', // Assuming default value
            discount: salesRule.description ?? '',
            condition: salesRule.name ?? '',
            type: 'Sản phẩm nhất định', // Assuming default value
            progressValue: 0, // Assuming default value
            expired: salesRule.to_date ?? '',
            productDescription: salesRule.description ?? '',
            brand_image: '',
            name: salesRule.name ?? '',
        };
    };

    const mapSalesRuleToContent = (salesRule: SalesRule): CouponContent => {
        return {
            title: salesRule.name ?? 'Ưu đãi',
            usageNotice: salesRule.description ?? 'Lượt sử dụng còn hạn. Nhanh tay kéo lợi bạn nhé!',
            validityPeriod: 'Thời gian sử dụng mã',
            devices: 'Thiết bị',
            payment: 'Thanh toán',
            shipping: 'Đơn vị vận chuyển',
            products: 'Sản phẩm',
            learnMore: 'Tìm hiểu thêm',
            paymentDescription: 'Tất cả các hình thức thanh toán',
        };
    };

    return { mapSalesRuleToCouponType, mapSalesRuleToContent };
};
